/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DealInputs */

const cs_enum_deal = /** @type {(inputs: Enum_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod`)
};

const en_enum_deal = /** @type {(inputs: Enum_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal`)
};

/**
* | output |
* | --- |
* | "Deal" |
*
* @param {Enum_DealInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_deal = /** @type {((inputs?: Enum_DealInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DealInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_deal(inputs)
	return cs_enum_deal(inputs)
});